<template>
  <nav class="bottom-nav" :aria-label="$t('nav')">
    <div class="inner" :style="{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }">
      <router-link v-for="item in items" :key="item.key" :to="item.to" class="item"
        :class="{ active: $route.meta.nav == item.key }">
        <span class="material-symbols-outlined">{{ item.icon }}</span>
        <span class="label">{{ $t(item.label) }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
import config from '@/system/request/config';

export default {
  data() {
    return {
      items: [
        { key: 'wallet', to: '/wallet', icon: 'account_balance_wallet', label: 'nav_wallet' },
        { key: 'convert', to: '/convert', icon: 'currency_exchange', label: 'nav_convert' },
        { key: 'release', to: '/release', icon: 'motion_photos_on', label: 'nav_release' },
        { key: 'team', to: '/team', icon: 'hub', label: 'nav_team' },
      ].filter(item => (item.key != 'team' || config.showTeam) && (item.key != 'release' || config.showRelease)),
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 0 12px calc(12px + env(safe-area-inset-bottom));
  pointer-events: none;
}

.inner {
  pointer-events: auto;
  max-width: calc(var(--page-max) - 24px);
  height: var(--nav-h);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  padding: 8px;
  border-radius: 24px;
  background: rgba(11, 14, 20, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid var(--hairline);
  border-top-color: rgba(255, 229, 143, 0.3);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.9);
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 16px;
  color: var(--steel);
  font-size: 11px;
  font-weight: 500;
  transition: color 0.15s, background 0.15s;

  .material-symbols-outlined { font-size: 24px; }

  &.active {
    color: var(--gold-text);
    background: rgba(212, 175, 55, 0.1);
    .material-symbols-outlined { font-variation-settings: 'FILL' 1, 'wght' 500; }
  }
}
</style>
